import CopyScenario from './CopyScenario';

export default CopyScenario;
